import { createContext } from 'react';
import type { CommunityBridge } from './types';

/** The bridge the Community screens use (tests hand in a fake one). Kept apart from bridge.ts so it costs no socket.io. */
export const BridgeContext = createContext<CommunityBridge | null>(null);
